import { CheckCircle, ExternalLink, ShieldCheck } from "lucide-react";
import { Button } from "@/components/ui/button";
import { SILJA_LINE_URL } from "@/config/event";

export const VipConfirmation = ({ name, email }) => (
  <div
    className="py-3 text-left opacity-0 animate-fade-in-up"
    data-testid="vip-confirmation"
    role="status"
    aria-live="polite"
  >
    <div className="flex items-start gap-4 border-b border-[#FFD700]/20 pb-5">
      <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-full bg-[#FFD700] shadow-[0_0_28px_rgba(255,215,0,0.28)]">
        <CheckCircle className="h-6 w-6 text-black" aria-hidden="true" />
      </div>
      <div>
        <p className="mb-1 text-xs font-bold uppercase text-[#FFD700]">
          Registreringen är bekräftad
        </p>
        <h2
          className="font-heading text-3xl uppercase leading-none text-white md:text-4xl"
          data-testid="vip-confirmation-heading"
        >
          Grattis!
        </h2>
      </div>
    </div>

    <p className="mt-5 text-base leading-relaxed text-gray-200" data-testid="vip-confirmation-message">
      Du har nu skrivit upp dig för <strong className="text-[#FFD700]">VIP-band</strong> på
      Dunderkryssningen. För att VIP-bandet ska gälla måste du nu boka din hytt genom Silja
      Lines hemsida.
    </p>

    <div className="my-5 border-l-2 border-[#FFD700] bg-[#151515] px-4 py-3" data-testid="vip-booking-requirement">
      <div className="mb-2 flex items-center gap-2 text-[#FFD700]">
        <ShieldCheck className="h-4 w-4" aria-hidden="true" />
        <span className="text-xs font-bold uppercase">Viktigt vid bokningen</span>
      </div>
      <p className="text-sm leading-relaxed text-gray-300">
        Använd samma namn och e-postadress som du registrerade på VIP-sidan:
      </p>
      <dl className="mt-3 grid gap-2 text-sm">
        <div className="grid grid-cols-[4.5rem_1fr] gap-2">
          <dt className="text-gray-500">Namn</dt>
          <dd className="break-words font-semibold text-white" data-testid="vip-confirmation-name">{name}</dd>
        </div>
        <div className="grid grid-cols-[4.5rem_1fr] gap-2">
          <dt className="text-gray-500">E-post</dt>
          <dd className="break-all font-semibold text-white" data-testid="vip-confirmation-email">{email}</dd>
        </div>
      </dl>
    </div>

    <Button
      asChild
      className="h-auto min-h-14 w-full whitespace-normal rounded-sm bg-[#FFD700] px-5 py-4 text-center text-sm font-bold uppercase text-black shadow-[0_0_25px_rgba(255,215,0,0.2)] transition-[transform,background-color,box-shadow] duration-300 hover:scale-[1.02] hover:bg-[#E5C100] hover:shadow-[0_0_35px_rgba(255,215,0,0.35)]"
    >
      <a
        href={SILJA_LINE_URL}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="silja-booking-button"
      >
        Boka din hytt hos Silja Line
        <ExternalLink className="h-4 w-4" aria-hidden="true" />
      </a>
    </Button>
  </div>
);